import Header from './Header';
import Biodiversity from './Biodiversity';
import Risk from './Risk';
import NonContiguousForm from '../Waterways/NonContiguousForm';
const WaterwayItemCommonTop = ({ handleFormFieldChange,isNonContiguous,masterWaterwayItemList,formContiguous,itemPopup,itemList,setFormErrors, setItemPopupRisk, setRiskLookupList, handleMultiSelectRiskChange, handleLMUChange, handleMultiSelectCategoryChange, itemPopupHeader, itemTypeFieldList, itemPopupItemSepcQ, itemPopupMaptype, handleItemPopupHeaderChange, itemPopupBiodiversity, largeEnterpriseDetails, formErrors, riskLookupList,
    handleItemPopupBiodiversity, itemPopupRisk, handleItemPopupRisk, Section, handleMultiSelectEnterpriseChange, handleMultiSelectContaminantChange, handleMultiSelectRiskDataGroupChange, handleMultiSelectActivityGroupChange, handleMultiSelectActivitySubGroupChange }) => {
    return (
        <div>
            <Header Section={Section} handleLMUChange={handleLMUChange} itemPopupHeader={itemPopupHeader} itemTypeFieldList={itemTypeFieldList} itemPopupItemSepcQ={itemPopupItemSepcQ} itemPopupMaptype={itemPopupMaptype} formErrors={formErrors} largeEnterpriseDetails={largeEnterpriseDetails}
                handleItemPopupHeaderChange={handleItemPopupHeaderChange} >
            </Header>
            {itemPopup.markertype == 'polyline' && itemList != undefined && itemList.length > 1 && !itemPopup.isMaster &&
                <>
                <NonContiguousForm formErrors={formErrors}  itemPopup={itemPopup}
                    form={formContiguous} masterWaterwayItemList={masterWaterwayItemList} isNonContiguous={isNonContiguous}
                        handleFormFieldChange={(e) => handleFormFieldChange(e)} />
                    <br />
                </>
            }

            {/*{Section != 'Community & Cultural Significance' && itemPopupBiodiversity.isVisible ?*/}
            {/*    <Biodiversity itemPopupBiodiversity={itemPopupBiodiversity}*/}
            {/*        handleItemPopupBiodiversity={handleItemPopupBiodiversity} >*/}
            {/*    </Biodiversity> : ''}*/}

            {!isNonContiguous &&
                <>
                {Section != 'Community & Cultural Significance' && Section != 'InfrastructureMap' && Section != 'InfrastructureRisk' && Section != 'WaterwaysMap' && Section != 'WaterwaysRisk' && <>
                        <Risk setFormErrors={setFormErrors} itemPopupHeader={itemPopupHeader} handleMultiSelectCategoryChange={handleMultiSelectCategoryChange} formErrors={formErrors} itemPopupRisk={itemPopupRisk} riskLookupList={riskLookupList} handleMultiSelectRiskChange={handleMultiSelectRiskChange}
                            handleItemPopupRisk={handleItemPopupRisk} handleMultiSelectEnterpriseChange={handleMultiSelectEnterpriseChange}
                            handleMultiSelectContaminantChange={handleMultiSelectContaminantChange}
                            handleMultiSelectRiskDataGroupChange={handleMultiSelectRiskDataGroupChange}
                            handleMultiSelectActivityGroupChange={handleMultiSelectActivityGroupChange} setItemPopupRisk={setItemPopupRisk}
                            handleMultiSelectActivitySubGroupChange={handleMultiSelectActivitySubGroupChange} setRiskLookupList={setRiskLookupList}></Risk>
                        <br />
                    </>}
                </>
            }

        </div>
    )
}
export default WaterwayItemCommonTop